import { HStack, Icon, useColorModeValue, Text, PopoverTrigger } from '@chakra-ui/react';
import React from 'react';
import { MdDateRange } from 'react-icons/md';
import { useIntl } from 'react-intl';
import { SingleDatepicker } from '../calendarPicker';

type SuDateInputProps = {
    value?: Date;
    onChange: (date: Date | null) => void;
    size?: string;
    containerRef?: React.MutableRefObject<null>;
};

export const SuDateInput: React.FC<SuDateInputProps> = ({ value, onChange, size = 'md', containerRef }) => {
    const borderColor = useColorModeValue('gray.300', 'gray.500');
    const backgroundColor = useColorModeValue('gray.200', 'gray.600');
    const intl = useIntl();

    return (
        <>
            <SingleDatepicker portalRef={containerRef} onDateChange={(date) => onChange(date)} usePortal date={value}>
                {(date) => (
                    <PopoverTrigger>
                        <HStack
                            borderColor={borderColor}
                            cursor={'pointer'}
                            width={'fit-content'}
                            minW={'fit-content'}
                            borderRadius={'xl'}
                            borderWidth={1}
                            justify={'center'}
                            p={2}
                            px={2}
                            spacing={2}
                            backgroundColor={backgroundColor}
                        >
                            <Icon as={MdDateRange} />
                            <Text fontSize={size} fontWeight={'500'}>
                                {value ? intl.formatDate(date) : intl.formatMessage({ id: 'selectDate' })}
                            </Text>
                        </HStack>
                    </PopoverTrigger>
                )}
            </SingleDatepicker>
        </>
    );
};
